import React from 'react';

import { Text, Skeleton, Group } from '@mantine/core';
import { IconCircleCheck, IconLock } from '@tabler/icons-react';
import usePaymentMethod from 'hooks/paymentMethod/usePaymentMethod';
import { getPaymentMethodName } from 'utils/formatters';

import DetailField from './DetailField';
import { useCheckout } from '../../CheckoutContext';

const PaymentMethod = (): JSX.Element => {
  const { form, billingPlan } = useCheckout();

  const selectedPaymentMethodId = form.values.paymentMethod.selectedPaymentMethodId;

  const {
    data: paymentMethodData,
    isSuccess,
    isLoading,
    isError,
  } = usePaymentMethod(selectedPaymentMethodId ?? undefined);

  return (
    <DetailField label='Payment Method'>
      {isError && (
        <Text size='sm' color='red'>
          Not found
        </Text>
      )}

      {isLoading && <Skeleton h='lg' />}

      {isSuccess && paymentMethodData?.data && (
        <Group noWrap>
          {paymentMethodData?.data.isLocked && <IconLock color='red' size='10px' />}
          <Text size='sm' color='dimmed'>
            {getPaymentMethodName(paymentMethodData?.data)}
          </Text>
        </Group>
      )}

      {!selectedPaymentMethodId && !billingPlan.salesPortalRequiresPaymentMethod && (
        <Text size='sm' color='dimmed'>
          N/A
        </Text>
      )}

      {!selectedPaymentMethodId && billingPlan.salesPortalRequiresPaymentMethod && (
        <Group noWrap spacing='0.5rem'>
          <Text size='sm' color='dimmed'>
            Added
          </Text>
          <IconCircleCheck color='green' size='16' />
        </Group>
      )}
    </DetailField>
  );
};

export default PaymentMethod;
